import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(4),
  },
  fieldGroup: {
    padding: theme.spacing(2),
  },
  inputForm: {
    marginTop: theme.spacing(2),
  },
  botaoAddFiliacao: {
    marginLeft: theme.spacing(1),
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '12px',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginTop: theme.spacing(4),
  },
  dividerTitle: {
    marginBottom: theme.spacing(2),
  },
  grupoEspelho: {
    padding: theme.spacing(2),
  },
  dadoEspelho: {
    fontSize: '13px',
    color: theme.palette.text.secondary,
    fontWeight: 'bold',
  },
  imageEmpty: {
    display: 'block',
    margin: '0 auto',
    maxWidth: '200px',
  },
  textEmpty: {
    textAlign: 'center',
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
